import { API } from "aws-amplify";

import {
	RSVP_LOOKUP_INITIATED,
	RSVP_LOOKUP_FAILED,
	RSVP_LOOKUP_SUCCEEDED
} from '../state/actions/RsvpActions';


export const lookupRsvpCode = (rsvpCode) => {
  return new Promise(async (resolve, reject) => {
    try {
			let result = API.get("invitations", `/invitations/${rsvpCode}`)
			resolve(result);
    } catch(e) {
      console.log(e);
    }
		resolve(false);
  });
}

export const recordResponses = (rsvpCode, guestResponses) => {
  return new Promise(async (resolve, reject) => {
    try {
			let result = API.put("invitations", `/invitations/${rsvpCode}`, {
				body: guestResponses
			});
			resolve(result);
    } catch(e) {
      console.log(e);
    }
		resolve(false);
  });
}



// WEBPACK FOOTER //
// ./services/RsvpService.js